import { apiClient } from '../../../../core/api/client';
import type {
  CoverageScope,
  ServiceRange,
  SpecialtyCoverageState,
} from '@/shared/components/specialty-coverage';

/** PATCH/GET specialties[] item — mirrors backend SpSpecialtyCoverageResponseDto. */
export type SpecialtyCoveragePayloadItem = {
  specialtyId: string;
  coverageScope: CoverageScope | null;
  serviceRanges: ServiceRange[];
  coverageStates: SpecialtyCoverageState[];
};

export type SpecialtyCoverageResponse = {
  specialties: SpecialtyCoveragePayloadItem[];
};

export type UpdateSpecialtyCoveragePayload = {
  specialties: Array<{
    specialtyId: string;
    coverageScope: CoverageScope;
    serviceRanges: ServiceRange[];
    coverageStates: SpecialtyCoverageState[];
  }>;
};

const ENDPOINT = '/service-providers/profile/specialty-coverage';

/** GET editor-shaped specialties[] — round-trips with PATCH, no transform. */
export async function fetchSpecialtyCoverage(): Promise<SpecialtyCoverageResponse> {
  const { data } = await apiClient.get<SpecialtyCoverageResponse>(ENDPOINT);
  return data;
}

/** PATCH specialties[] — coverage + service ranges only; immediate effect. */
export async function updateSpecialtyCoverage(
  payload: UpdateSpecialtyCoveragePayload,
): Promise<SpecialtyCoverageResponse> {
  const { data } = await apiClient.patch<SpecialtyCoverageResponse>(ENDPOINT, payload);
  return data;
}
